<template>
  <label :class="['block', wrapperClass]">
    <span v-if="label" class="label">{{ label }}</span>
    <Calendar
      :model-value="dateValue"
      :placeholder="placeholder"
      :required="required"
      append-to="body"
      date-format="dd/mm/yy"
      input-class="field"
      class="qlts-date-picker"
      v-bind="calendarAttrs"
      @update:modelValue="onUpdate"
    />
  </label>
</template>

<script lang="ts">
import { computed, useAttrs } from "vue";
import Calendar from "primevue/calendar";

const parseIsoDate = (value: unknown) => {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

const parseDisplayDate = (value: string) => {
  const match = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) return null;
  return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
};

const toIsoDate = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export default {
  components: { Calendar },
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "dd/mm/yyyy" },
    required: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "change"],
  setup(props: any, { emit }: any) {
    const attrs = useAttrs();
    const wrapperClass = computed(() => attrs.class);
    const calendarAttrs = computed(() => {
      const next = { ...attrs };
      delete next.class;
      return next;
    });
    const dateValue = computed(() => parseIsoDate(props.modelValue));

    const onUpdate = (value: Date | string | null) => {
      let date = value instanceof Date ? value : null;
      if (!date && typeof value === "string") {
        date = parseDisplayDate(value);
      }

      const nextValue = date && !Number.isNaN(date.getTime()) ? toIsoDate(date) : "";
      emit("update:modelValue", nextValue);
      emit("change", nextValue);
    };

    return {
      calendarAttrs,
      dateValue,
      onUpdate,
      wrapperClass,
    };
  },
};
</script>

<style scoped>
.qlts-date-picker {
  display: block;
  width: 100%;
}
</style>
